<!--
 * @Author: zyy
 * @Date: 2023-03-13 10:23:25
 * @LastEditors: zyy
 * @LastEditTime: 2023-03-15 11:09:58
 * @Description: default
-->
<!--
 * @Author: zyy
 * @Date: 2022-09-21 13:19:36
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-16 17:42:30
 * @Description: default
-->
<template>
    <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
        <a-card :bordered="false">
            <div class="flex">
                <a-menu style="width: 256px" :default-selected-keys="['1']" mode="inline" @click="handleClick">
                    <a-menu-item key="1">商城首页</a-menu-item>
                    <a-menu-item key="2">积分商城首页</a-menu-item>
                </a-menu>
                <div class="page-box">
                    <GoodsPage v-if="currentKey == 1"></GoodsPage>
                    <integralPage v-if="currentKey == 2"></integralPage>
                </div>
            </div>
        </a-card>
    </div>
</template>
  
<script>

import { TJListMixin } from '@/mixins/list.js'
import GoodsPage from './goodsPage.vue'
import integralPage from './integralPage.vue';
export default {
    mixins: [TJListMixin],
    components: {
        GoodsPage,
        integralPage
    },
    data() {
        return {
            currentKey: 1
        };
    },
    methods: {
        handleClick(e) {
            this.currentKey = e.key
            // console.log('click', e);
        },
    },
};
</script>
<style scoped lang="less">
.flex {
    display: flex;
}

.page-box {
    margin-left: 50px;
}
</style>
  